// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px;
  padding-bottom: 40px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
  border-radius: 16px;
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
}
.wrapper .title {
  text-align: start;
  padding: 20px 0px;
  color: var(--accent-color);
}
.wrapper .description {
  font-family: AppFontMedium;
  font-size: 14px;
  color: var(--color-black);
  padding: 5px 0px 10px;
  text-align: center;
  text-transform: uppercase;
}
.content_block {
  height: calc(100% - 124px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  width: 100%;
  margin-top: 3%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.footer-btn ion-button {
  margin: 5px 0px;
  width: 90%;
  min-height: 60px;
  text-transform: uppercase;
  font-size: 15px;
}
.footer-btn ion-button.checkout-btn:hover {
  --background: var(--accent-color) !important;
}
.footer-btn ion-button.cancel-btn {
  --background: transparent !important;
  color: var(--color-black);
  text-decoration: underline;
}
.footer-btn ion-button.cancel-btn:hover {
  --background: none !important;
}
.footer-btn p {
  color: var(--accent-color);
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: var(--color-black);
  text-align: left;
  padding-top: 6px;
}

.footer-btn-text {
  font-size: 16px !important;
  color: white;
  text-transform: capitalize;
  font-family: AppFont, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;EACA,mBAAA;AADD;AAGC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AADF;AAGE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AADH;AAKC;EACC,kBAAA;EACA,WAAA;AAHF;AAMC;EACC,iBAAA;EACA,iBAAA;EACA,0BAAA;AAJF;AAOC;EACC,0BAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AALF;AAaA;EACC,0BAAA;EACA,gBAAA;EACA,WAAA;AAXD;;AAcA;EAEC,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAZD;AAcC;EACC,eAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EAkBA,eAAA;AA7BF;AAcG;EACC,4CAAA;AAZJ;AAgBE;EACC,oCAAA;EACA,yBAAA;EACA,0BAAA;AAdH;AAgBG;EACC,6BAAA;AAdJ;AAoBC;EACC,0BAAA;AAlBF;;AAsBA;EACC,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAnBD;;AAuBA;EACC,0BAAA;EACA,YAAA;EACA,0BAAA;EACA,gCAAA;AApBD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 20px;\n\tpadding-bottom: 40px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\tborder-radius: 16px;\n\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t}\n\n\t.header-wrapper {\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t}\n\n\t.title {\n\t\ttext-align: start;\n\t\tpadding: 20px 0px;\n\t\tcolor: var(--accent-color);\n\t}\n\n\t.description {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 14px;\n\t\tcolor: var(--color-black);\n\t\tpadding: 5px 0px 10px;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\n\tion-col {\n\t}\n}\n\n\n.content_block {\n\theight: calc(100% - 124px);\n\toverflow-y: auto;\n\twidth: 100%;\n}\n\n.footer-btn {\n\t// position: fixed;\n\twidth: 100%;\n\tmargin-top: 3%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\n\tion-button {\n\t\tmargin: 5px 0px;\n\t\twidth: 90%;\n\t\tmin-height: 60px;\n\t\ttext-transform: uppercase;\n\n\t\t&.checkout-btn {\n\t\t\t&:hover {\n\t\t\t\t--background: var(--accent-color) !important;\n\t\t\t}\n\t\t}\n\n\t\t&.cancel-btn {\n\t\t\t--background: transparent !important;\n\t\t\tcolor: var(--color-black);\n\t\t\ttext-decoration: underline;\n\n\t\t\t&:hover {\n\t\t\t\t--background: none !important;\n\t\t\t}\n\t\t}\n\n\t\tfont-size: 15px;\n\t}\n\tp {\n\t\tcolor: var(--accent-color);\n\t}\n}\n\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: var(--color-black);\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n\n\n.footer-btn-text {\n\tfont-size: 16px !important;\n\tcolor: white;\n\ttext-transform: capitalize;\n\tfont-family: AppFont, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
